import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

import { LoyaltyCurrencyIcon, LoyaltyCurrencyChange } from '@ocx/feat-loyalty-currency';

import { ReceiptOffer, ReceiptPointChangeType } from '../../../../receipts.types';
import { LoyaltyItemContent } from '../loyalty-item-content';
import { messages } from '../../receipt-loyalty-card.messages';

export type PointChangeItemProps = {
  pointsDiff: number;
  appliedOffersNumber: number;
  type: ReceiptPointChangeType;
  offers: ReceiptOffer[];
};

const RECEIPT_LINE_ITEMS: Record<ReceiptPointChangeType, { text: MessageDescriptor; icon?: React.ReactNode }> = {
  spent: {
    text: messages['receipt:loyalty-card:points-spent'],
    icon: <LoyaltyCurrencyIcon variant="multiple" />,
  },
  earned: {
    text: messages['receipt:loyalty-card:points-earned'],
    icon: <LoyaltyCurrencyIcon variant="multiple" />,
  },
  refund: {
    text: messages['receipt:loyalty-card:points-refund'],
    icon: <FileDownloadOutlinedIcon width={24} sx={{ color: 'Receipts.refundedIconColor' }} />,
  },
};

export const PointChangeItem = (props: PointChangeItemProps) => {
  const { type, pointsDiff, appliedOffersNumber, offers } = props;

  return (
    <LoyaltyItemContent
      icon={RECEIPT_LINE_ITEMS[type].icon}
      iconBackgroundColor="Receipts.currencyBackground"
      title={<FormattedMessage {...RECEIPT_LINE_ITEMS[type].text} />}
      value={
        <LoyaltyCurrencyChange
          points={pointsDiff}
          template="value-icon"
          typographyProps={{ variant: 'subtitle1', noWrap: true }}
        />
      }
      appliedOffersNumber={appliedOffersNumber}
      offers={offers}
    />
  );
};
